import { createFileRoute } from '@tanstack/react-router';
import { usePageTitle } from '../../../lib/hooks';
import { OrgUnitTree } from '../../../features/org/components/OrgUnitTree';
import { PageHeader } from '../../../components/layout/PageHeader';

export const Route = createFileRoute('/_auth/settings/branches')({
  component: BranchesSettingsPage,
});

function BranchesSettingsPage() {
  usePageTitle('Branches Settings');
  return (
    <div className="space-y-6">
      <PageHeader
        title="Branch Management"
        subtitle="Manage your organizational hierarchy, regions, and branches."
      />

      <OrgUnitTree />
    </div>
  );
}
